import { render, staticRenderFns } from "./ReportCenterTable.vue?vue&type=template&id=77df2234&"
import script from "./ReportCenterTable.vue?vue&type=script&lang=js&"
export * from "./ReportCenterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports